import { useState, useCallback } from 'react';
import { IImageThumbnail } from '../../../Entities';

let CATEGORY_NORMAL = 1;
let CATEGORY_EXTRA = 2;

type UseImageCategoryOverridesArgs = {
    allImages: IImageThumbnail[];
};

type UseImageCategoryOverridesResult = {
    categoryOverrides: Map<number, number>;
    getEffectiveCategory: (image: IImageThumbnail) => number;
    toggleCategory: (imageId: number) => void;
};

export function useImageCategoryOverrides({
    allImages
}: UseImageCategoryOverridesArgs): UseImageCategoryOverridesResult {
    let [categoryOverrides, setCategoryOverrides] = useState<Map<number, number>>(new Map());

    let getEffectiveCategory = useCallback(
        function (image: IImageThumbnail): number {
            if (categoryOverrides.has(image.id)) {
                return categoryOverrides.get(image.id);
            }
            return image.categoryId;
        },
        [categoryOverrides]
    );

    let toggleCategory = useCallback(
        function (imageId: number) {
            setCategoryOverrides(function (prev) {
                let next = new Map(prev);
                let image = allImages.find(function (img) {
                    return img.id === imageId;
                });
                if (!image || image.isCustomerApproved) {
                    return prev;
                }
                let currentCategory = next.has(imageId) ? next.get(imageId) : image.categoryId;

                if (currentCategory === CATEGORY_NORMAL) {
                    next.set(imageId, CATEGORY_EXTRA);
                } else {
                    next.set(imageId, CATEGORY_NORMAL);
                }
                return next;
            });
        },
        [allImages]
    );

    return {
        categoryOverrides,
        getEffectiveCategory,
        toggleCategory
    };
}
